import { CartItemPrice } from "./cartItemPrice";
import { RemoveFromCartButton } from "./removeFromCartButton";
import React from "react";

export interface ScanToOrderCartItemRightProps {
  price: number;
  index: number;
  // eslint-disable-next-line no-unused-vars
  removeFromCart?: (event: React.MouseEvent, index: number) => void;
  itemName?: string,
}

export const ScanToOrderCartItemRight = ({
  price,
  removeFromCart,
  index,
  itemName,
}: ScanToOrderCartItemRightProps) => {
  return (
    <div className="flex flex-col justify-start items-end">
      <CartItemPrice price={price} />
      {removeFromCart && (
        <RemoveFromCartButton index={index} removeFromCart={removeFromCart} itemName={itemName} />
      )}
    </div>
  );
};
